import requestAction from '../../utils/requestAction'

export const fetchProducts = (params: string = "") =>
  requestAction('PRODUCT_LIST', params)(`products`, 'GET')

export const fetchActiveProducts = (params: string = "") =>
  requestAction('PRODUCT_LIST', params ? `${params}&status=A` : '?status=A')(`products`, 'GET')

export const fetchAllProducts = () =>
  fetchProducts('?all=true')